import React from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { Divider } from 'semantic-ui-react'
import { Cont, SContDetail, TableCont } from './styled'
import { StdCard } from 'components'
import { DataCell } from '../DataCell'
import PRGeneral from '../PRGeneral'
import { ProcessRow } from '../PRProcessHistory/ProcessRow'
import { costCenterColumn, wbsColumn, internalOrderColumn, migrationColumn } from '../../Create/data'

const PRSummary = (props) => {
  const { prDetail } = props
  const prData = prDetail.data || {}
  const prLoading = prDetail.loading

  const setLastComment = () => {
    if (!prDetail.loading && prData.comments.length > 0) {
      return (
        <div style={{ marginTop: '1rem' }}>
          <div style={{ fontWeight: 'bold' }}>Last Comment</div>
          <div style={{ marginTop: '1rem', flex: 1 }}>
            <ProcessRow data={prData.comments[0]} />
          </div>
        </div>)
    }
    return null
  }

  return (
    <div>
      <StdCard title='Summary Information' style={{ width: '100%' }} enableCollapse>
        <div style={{ display: 'flex' }}>
          <Cont>
            <SContDetail>
              <div className='toleft'>
                <DataCell right title='Total Amount' value={!prLoading && prData.totalAmount} currency={!prLoading && prData.currency} isNumber />
                <DataCell right title={`VAT (${prData.vatRate || '0'}%)`} value={!prLoading && prData.vatAmount} currency={!prLoading && prData.currency} isNumber />
                <DataCell right title='Net Amount' value={!prLoading && prData.totalAmountIncludeVat} currency={!prLoading && prData.currency} isNumber />
              </div>
              <div />
            </SContDetail>
            <SContDetail>
              <DataCell title='PR By GOA' value={!prLoading && prData.goaItemName} />
              <div />
            </SContDetail>
          </Cont>
        </div>
        <Divider />
        {!prLoading && (prData.budgetsCostCenter.length > 0 || prData.budgetsWbs.length > 0 || prData.budgetsInternalOrder.length > 0 || prData.budgetsMigrate.length > 0) &&
          <div style={{ fontWeight: 'bold' }}>Budget Information</div>
        }
        <div style={{ marginTop: '1rem', flex: 1 }}>
          {!prLoading && prData.budgetsCostCenter.length > 0 &&
            <TableCont>
              <span className='tableTitle'>Cost Center</span>
              <ReactTable
                columns={costCenterColumn}
                data={!prLoading && (prData.budgetsCostCenter || [])}
                minRows={1}
                defaultPageSize={10}
                showPagination={!prLoading && prData.budgetsCostCenter.length > 10}
              />
            </TableCont>}
          {!prLoading && prData.budgetsWbs.length > 0 &&
            <TableCont>
              <span className='tableTitle'>Work Breakdown Structure (WBS)</span>
              <ReactTable
                columns={wbsColumn}
                data={!prLoading && (prData.budgetsWbs || [])}
                minRows={1}
                defaultPageSize={10}
                showPagination={!prLoading && prData.budgetsWbs.length > 10}
              />
            </TableCont>}
          {!prLoading && prData.budgetsInternalOrder.length > 0 &&
            <TableCont>
              <span className='tableTitle'>Internal Order</span>
              <ReactTable
                columns={internalOrderColumn}
                data={!prLoading && (prData.budgetsInternalOrder || [])}
                minRows={1}
                defaultPageSize={10}
                showPagination={!prLoading && prData.budgetsInternalOrder.length > 10}
              />
            </TableCont>}
          {!prLoading && prData.budgetsMigrate.length > 0 &&
            <TableCont>
              <span className='tableTitle'>Budgets</span>
              <ReactTable
                columns={migrationColumn}
                data={!prLoading && (prData.budgetsMigrate || [])}
                minRows={1}
                defaultPageSize={10}
                showPagination={!prLoading && prData.budgetsMigrate.length > 10}
              />
            </TableCont>}
        </div>
        {setLastComment()}
      </StdCard>
      <PRGeneral />
    </div>
  )
}

const mapStateToProps = (state) => ({
  prDetail: state.pr.prDetail
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PRSummary)
